function mobileBreakpoint () { return 887 }

export default function initStickyMobileCtas () {
  const bar = document.querySelector('.vjs-scroll-sticky-mobile-bar')
  const sentinel = document.querySelector('.vjs-scroll-sticky-mobile-bar-sentinel')
  if (!bar || !sentinel) return

  function setStuck (stuck) {
    const alreadyStuck = bar.dataset.stuck === 'true'
    if (stuck === alreadyStuck) return
    if (stuck) {
      sentinel.style.height = `${bar.offsetHeight}px`
      bar.dataset.stuck = 'true'
    } else {
      bar.dataset.stuck = 'false'
      sentinel.style.height = ''
    }
  }

  function update () {
    if (window.innerWidth >= mobileBreakpoint()) {
      setStuck(false)
      return
    }
    setStuck(sentinel.getBoundingClientRect().top < 0)
  }

  window.addEventListener('scroll', update, { passive: true })
  window.addEventListener('resize', update)
  update()
}
